import type { ResultOf } from "@graphql-typed-document-node/core";
import type { ShareAnswersType, SubmittedTaskStatus } from "../../shared/types";
import { graphql } from "../gql";

export const query = graphql(`
    query AppTaskChoiceQuery($id: ID!) {
        taskChoice(id: $id) {
            id
            icon
            name
            url
            description
            callToAction
            deadline
            complete
            learningPathItem {
                id
                tasks {
                    id
                    icon
                    miles
                    name
                    url
                    shareAnswers
                    submittedTask {
                        id
                        url
                        status
                    }
                }
            }
        }
    }
`);

export type ITaskChoice = NonNullable<ResultOf<typeof query>["taskChoice"]>;
export type ITask = ITaskChoice["learningPathItem"]["tasks"][number];

export function taskFinished(task: { submittedTask: { status: SubmittedTaskStatus } | null }): boolean {
    return task.submittedTask?.status === "accepted";
}

export function taskUndecied(task: { submittedTask: { status: SubmittedTaskStatus } | null }): boolean {
    return task.submittedTask?.status === "undecided";
}

export function taskRedo(task: { submittedTask: { status: SubmittedTaskStatus } | null }): boolean {
    return task.submittedTask?.status === "rejected";
}

export function taskSharingAnswers(task: { shareAnswers: ShareAnswersType }): boolean {
    return task.shareAnswers !== "no_one";
}
